import { IApplicationState } from '../../types/redux';

export const selectIsFoldersUnsupportedModalOpen = (state: IApplicationState) =>
  Boolean(state.folders.isUnsupportedFoldersModalVisible);
